import React, { Component } from "react";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import "../../styles/css/ElevationForm/elevationForm.css";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Button } from "bootstrap-4-react";

const API_URL1 =
  "https://gis.suffolkcountyny.gov/server/rest/services/Locators/AddressMultiRole/GeocodeServer/suggest?f=json&text=";

class SectionA extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [],
      isLoading: false,
      // selected: "",
      addressLine: [],
    };
  }
  // numbersplit = (str) => {
  //   if (str) {
  //     return str.substr(0, 3) + "." + str.substr(3);
  //   } else {
  //     return "";
  //   }
  // };

  removeMinus = (str) => {
    if (str) {
      return str.substr(2);
    } else {
      return "";
    }
  };
  render() {
    const {
      sectionA,
      onClickA,
      validateA,
      getlocation,
      stoploading,
    } = this.props;
    return (
      <div className="form-wrapper-elevation">
        <h2>PROPERTY INFORMATION</h2>
        {sectionA.isSubmittedA === false ? (
          <div className="err-msg-content">
            Something went wrong. Please try again.
          </div>
        ) : null}
        <table>
          <tbody>
            <tr>
              <td colSpan="6">
                <div className="question-wrapper">
                  <span>A1.</span>
                  <p className="qst-type">
                    Building Street Address (including Apt., Unit, Suite, and/or
                    Bldg. No.) or P.O. Route and Box No{" "}
                  </p>
                </div>
                <div className="input-box-wrapper">
                  <AsyncTypeahead
                    id="async-example"
                    placeholder={sectionA.addressLine.text}
                    selected={this.state.addressLine}
                    useCache={true}
                    clearButton
                    isLoading={this.state.isLoading}
                    labelKey={(option) => `${option.text}`}
                    onSearch={(query) => {
                      stoploading;
                      this.setState({ isLoading: true });
                      fetch(`${API_URL1}${query}&maxSuggestions=6`)
                        .then((resp) => resp.json())
                        .then((json) => {
                          this.setState({
                            isLoading: false,
                            options: json.suggestions,
                          });
                        });
                    }}
                    onChange={(addressLine) => {
                      this.setState({ addressLine });
                    }}
                    options={this.state.options}
                  />

                  <Button
                    onClick={() => getlocation(this.state.addressLine)}
                    className="verify-btn"
                  >
                    Verify & Autofill
                    {sectionA.isAddressVerify ? (
                      <CircularProgress className="circularColor1" />
                    ) : null}
                  </Button>

                  {sectionA.isLoadingAddress === false ? (
                    <span className="error-msg-text">
                      Please enter valid address
                    </span>
                  ) : null}

                  {validateA.message(
                    "address",
                    sectionA.addressLine,
                    "required",
                    {
                      className: "error-msg-text",
                    }
                  )}
                </div>
              </td>
            </tr>

            <tr>
              <td colSpan="6">
                <div className="question-wrapper">
                  <span>A2.</span>
                  <p className="qst-type">Building Owner's Name</p>
                </div>
                <div className="input-box-wrapper">
                  <input
                    type="text"
                    name="building_owner_name"
                    value={sectionA.building_owner_name}
                    onChange={onClickA}
                    className="form-input-box"
                    disabled={sectionA.city === ""}
                  />
                  {validateA.message(
                    "owner's name",
                    sectionA.building_owner_name,
                    "required|alpha_num_dash_space",
                    { className: "error-msg-text" }
                  )}
                </div>
              </td>
            </tr>

            <tr>
              <td colSpan="1">
                <p className="sub-question-text">City</p>
                <div className="input-box-wrapper">
                  <input
                    type="text"
                    name="city"
                    className="form-input-box"
                    value={sectionA.city}
                    onChange={onClickA}
                  />
                  {validateA.message(
                    "city",
                    sectionA.city,
                    "alpha_num_dash_space",
                    {
                      className: "error-msg-text",
                    }
                  )}
                </div>
              </td>
              <td colSpan="1">
                <p className="sub-question-text">State</p>
                <div className="input-box-wrapper">
                  <input
                    name="region"
                    type="text"
                    className="form-input-box"
                    value={sectionA.region}
                    onChange={onClickA}
                  />
                  {validateA.message(
                    "state",
                    sectionA.region,
                    "alpha_num_dash_space",
                    {
                      className: "error-msg-text",
                    }
                  )}
                </div>
              </td>
              <td colSpan="2">
                <p className="sub-question-text">ZIP</p>
                <div className="input-box-wrapper">
                  <input
                    type="text"
                    name="zipcode"
                    value={sectionA.zipcode}
                    className="form-input-box"
                    onChange={onClickA}
                  />
                  {validateA.message("zip", sectionA.zipcode, "numeric", {
                    className: "error-msg-text",
                  })}
                </div>
              </td>
            </tr>

            <tr>
              <td colSpan="6">
                <div className="question-wrapper">
                  <span>A3.</span>
                  <p className="qst-type">
                    Property Description (Lot and Block Numbers, Tax Parcel
                    Number, Legal Description, etc.)
                  </p>
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan="6">
                <div className="description-container">
                  <label> SCTM# :</label>
                  <label>Dist :</label>
                  <input
                    className="number-input"
                    type="text"
                    name="dist"
                    value={sectionA.dist}
                    onChange={onClickA}
                  />

                  <label>Sect :</label>
                  <input
                    className="number-input"
                    type="text"
                    name="sect"
                    // value={this.numbersplit(sectionA.sect)}
                    value={sectionA.sect}
                    onChange={onClickA}
                  />

                  <label>Block :</label>
                  <input
                    className="number-input"
                    type="text"
                    name="block"
                    // value={this.numbersplit(sectionA.block)}
                    value={sectionA.block}
                    onChange={onClickA}
                  />

                  <label>Lot :</label>
                  <input
                    className="number-input"
                    type="text"
                    name="lot"
                    // value={this.numbersplit(sectionA.lot)}
                    value={sectionA.lot}
                    onChange={onClickA}
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan="6">
                <div className="description-container">
                  {validateA.message("dist", sectionA.dist, "numeric", {
                    className: "error-msg-small",
                  })}

                  {validateA.message("sect", sectionA.sect, "numeric", {
                    className: "error-msg-small",
                  })}

                  {validateA.message("block", sectionA.block, "numeric", {
                    className: "error-msg-small",
                  })}

                  {validateA.message("lot", sectionA.lot, "numeric", {
                    className: "error-msg-small",
                  })}
                </div>
              </td>
            </tr>

            <tr>
              <td colSpan="6">
                <div className="question-wrapper">
                  <span>A4.</span>
                  <p className="qst-type">
                    Building Use (e.g : Residential, Non-Residential, Addition,
                    Accessory, etc)
                  </p>
                </div>
                <div className="input-box-wrapper">
                  <input
                    className="form-input-box"
                    text="text"
                    name="building_use"
                    value={sectionA.building_use}
                    onChange={onClickA}
                  />
                  {/* {validateA.message(
                    "building use",
                    sectionA.building_use,
                    "alpha_num_dash_space",
                    { className: "error-msg-text" }
                  )} */}
                </div>
              </td>
            </tr>

            <tr>
              <td colSpan="6">
                <div className="location-row-wrapper">
                  <div className="sub-text-label">
                    <label>A5. Latitude :</label>
                  </div>
                  <div className="sub-text-label">
                    <input
                      className="input-wrapper"
                      type="text"
                      name="lattitude"
                      value={sectionA.lattitude}
                      onChange={onClickA}
                    />
                    {/* {validateA.message("lattitude", sectionA.lattitude, "", {
                      className: "error-msg-text",
                    })} */}
                  </div>
                  <div className="sub-text-label">
                    <label>Longitude : </label>
                  </div>
                  <div className="sub-text-label">
                    <input
                      className="input-wrapper"
                      type="text"
                      name="longitude"
                      value={this.removeMinus(sectionA.longitude)}
                      onChange={onClickA}
                    />
                    {/* {validateA.message("longitude", sectionA.longitude, "", {
                      className: "error-msg-text",
                    })} */}
                  </div>

                  <div className="sub-text-label">
                    <div className="radio-btn-wrapper">
                      <label className="checkbox-label">
                        Horizontal Datum:
                      </label>
                      <input
                        className="radio-btn"
                        type="radio"
                        name="nad_data"
                        checked={sectionA.nad_data === "nad1927"}
                        value="nad1927"
                        onChange={onClickA}
                      />
                      <label className="checkbox-label">NAD 1927</label>
                      <input
                        className="radio-btn"
                        type="radio"
                        name="nad_data"
                        checked={sectionA.nad_data === "nad1983"}
                        value="nad1983"
                        onChange={onClickA}
                      />
                      <label className="checkbox-label">NAD 1983</label>
                      {validateA.message(
                        "horizontal datum",
                        sectionA.nad_data,
                        "alpha_num_dash_space",
                        {
                          className: "error-msg-text",
                        }
                      )}
                    </div>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan="6">
                <div className="question-wrapper">
                  <span> A6. </span>
                  <p className="qst-type">
                    Attach at least 2 photographs of the building if the
                    Certificate is being used to obtain flood insurance.(You
                    will be able to upload and label photographs at the end of
                    the form.)
                  </p>
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan="6">
                <div className="inline-question-container">
                  <span> A7. </span>
                  <label>Building Diagram Number</label>
                  <input
                    className="inline-input"
                    value={sessionStorage.getItem("diagram")}
                    onChange={onClickA}
                    name="diagram_no"
                    disabled
                  />
                  {/* {validateA.message(
                    "diagram_no",
                    sectionA.diagram_no,
                    "",
                    {
                      className: "error-msg-text",
                    }
                  )} */}
                </div>
              </td>
            </tr>

            <tr>
              <td colSpan="6">
                <div className="building-details-title">
                  <span>A8.</span>
                  <div>
                    <p>For a building with a crawlspace or enclosure(s):</p>
                  </div>
                </div>
              </td>
            </tr>

            <tr>
              <td colSpan="3">
                <div className="subquestion-container">
                  <span>(a)</span>
                  <div>Square footage of crawlspace or enclosure(s)</div>
                </div>
              </td>
              <td colSpan="3">
                {" "}
                <div className="input-box-wrapper">
                  <input
                    type="text"
                    className="form-input-box"
                    name="sq_ft_crawlspace"
                    value={sectionA.sq_ft_crawlspace}
                    onChange={onClickA}
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan="3">
                <div className="subquestion-container">
                  <span>(b)</span>
                  <div>
                    Number of permanent flood openings in the crawlspace or
                    enclosure(s) within 1.0 foot above adjacent grade
                  </div>
                </div>
              </td>
              <td colSpan="3">
                <div className="input-box-wrapper">
                  <input
                    type="text"
                    className="form-input-box"
                    name="flood_opening_crawlspace"
                    value={sectionA.flood_opening_crawlspace}
                    onChange={onClickA}
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan="3">
                <div className="subquestion-container">
                  <span>(c)</span>
                  <div>Total net area of flood openings in A8.b</div>
                </div>
              </td>
              <td colSpan="3">
                <div className="input-box-wrapper">
                  <input
                    type="text"
                    className="form-input-box"
                    name="net_area_crawlspace"
                    value={sectionA.net_area_crawlspace}
                    onChange={onClickA}
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan="3">
                <div className="subquestion-container">
                  <span>(d)</span>
                  <div>Engineered flood openings?</div>
                </div>
              </td>
              <td colSpan="3">
                <div className="radio-btn-group">
                  {" "}
                  <input
                    type="radio"
                    name="engineered_crawlspace"
                    checked={sectionA.engineered_crawlspace === "Yes"}
                    value="Yes"
                    className="checkbox-icon-btn"
                    onChange={onClickA}
                  />
                  <span className="checkbox-label">Yes</span>
                  <input
                    type="radio"
                    name="engineered_crawlspace"
                    checked={sectionA.engineered_crawlspace === "No"}
                    value="No"
                    className="checkbox-icon-btn"
                    onChange={onClickA}
                  />
                  <span className="checkbox-label">No</span>{" "}
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan="6">
                <div className="building-details-title">
                  <span>A9.</span>
                  <div>
                    <p>For a building with an attached garage:</p>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan="3">
                {" "}
                <div className="subquestion-container">
                  <span>(a)</span>
                  <div>Square footage of attached garage</div>
                </div>
              </td>
              <td colSpan="3">
                <div className="input-box-wrapper">
                  <input
                    type="text"
                    className="form-input-box"
                    name="sq_ft_garage"
                    value={sectionA.sq_ft_garage}
                    onChange={onClickA}
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan="3">
                {" "}
                <div className="subquestion-container">
                  <span>(b)</span>
                  <div>
                    Number of permanent flood openings in the attached garage
                    within 1.0 foot above adjacent grade
                  </div>
                </div>
              </td>
              <td colSpan="3">
                {" "}
                <div className="input-box-wrapper">
                  <input
                    type="text"
                    className="form-input-box"
                    name="flood_opening_garage"
                    value={sectionA.flood_opening_garage}
                    onChange={onClickA}
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan="3">
                {" "}
                <div className="subquestion-container">
                  <span>(c)</span>
                  <div>Total net area of flood openings in A9.b</div>
                </div>
              </td>
              <td colSpan="3">
                <div className="input-box-wrapper">
                  <input
                    type="text"
                    className="form-input-box"
                    name="net_area_garage"
                    value={sectionA.net_area_garage}
                    onChange={onClickA}
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan="3">
                {" "}
                <div className="subquestion-container">
                  <span>(d)</span>
                  <div>Engineered flood openings?</div>
                </div>
              </td>
              <td colSpan="3">
                {" "}
                <div className="radio-btn-group">
                  {" "}
                  <input
                    type="radio"
                    name="engineered_garage"
                    value="yes"
                    checked={sectionA.engineered_garage === "yes"}
                    className="checkbox-icon-btn"
                    onChange={onClickA}
                  />
                  <span className="checkbox-label">Yes</span>
                  <input
                    type="radio"
                    name="engineered_garage"
                    checked={sectionA.engineered_garage === "no"}
                    value="no"
                    className="checkbox-icon-btn"
                    onChange={onClickA}
                  />
                  <span className="checkbox-label">No</span>{" "}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default SectionA;



// WEBPACK FOOTER //
// ./src/pages/ElevationForm/SectionA.js